import type {CodeListMap, Data, Schema} from 'schemaDefinition/types';
import type {ValidationResult} from './types';
import {validResult} from './validResult';
import {validateSchema} from './validateSchema';

/**
 * Validate data according to schema
 *
 * @returns {
 *  valid: true/false
 *  errors: array of any errors found during validation
 * }
 */
export const validate = (
  data: Data,
  relatedScope: Data | undefined,
  schema: Schema | undefined,
  codelistMap: CodeListMap | undefined,
): ValidationResult => {
  // Assume valid
  const aggregateResult = validResult();

  if (!schema) {
    return aggregateResult;
  }

  // Validation uses the schema as-is (edit mode): the 'compare'-mode schema
  // simplification is a rendering concern and does not apply here.
  return validateSchema(
    schema,
    {
      valuePath: '',
      localScope: data,
      globalScope: data,
      relatedScope,
      value: data,
      codelistMap,
    },
    aggregateResult,
  );
};
